import { DataManager } from "@syncfusion/ej2-data";
import { EnumFilterAdaptor } from "./enum-filter-adaptor";

export class EnumFilterDataManager extends DataManager {
  constructor(dataSource: Object[]) {
    super({
      json: dataSource,
      dataType: 'json',
      offline: true,
      adaptor: new EnumFilterAdaptor()
    });
  }
}
